import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  subtitle: {
    color: '#424242',
    marginBottom: theme.spacing(2),
    fontSize: '1em',
    lineHeight: '1.5em',
  },
  modalImage: {
    borderRight: '1px solid rgb(189, 189, 189)',
    paddingRight: '12px',
    width: '37px',
    marginRight: '12px',
    verticalAlign: 'middle',
  },
  modalHeader: {
    borderBottom: '1px solid #E0E0E0',
    margin: '10px -16px 16px -16px',
  },
  modalPopup: {
    '&>*:nth-child(3)': {
      '&>*:nth-child(1)': {
        '@media (min-width: 1024px)': { width: '980px' },
      },
    },
  },
  searchField: {
    marginBottom: theme.spacing(1),
  },
  modalContent: {
    borderTop: '0',
  },
  CancelBtnColor: {
    color: '#00588f',
  },
  ContinueBtnColor: {
    color: '#fff',
    backgroundColor: '#00588f',
  },
}));
